import React from 'react';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="bg-brand-dark text-white pt-12 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-184">
      <div className="max-w-7xl mx-auto" data-id="element-185">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-186">
          <div className="flex flex-col space-y-8" data-id="element-187">
            <div className="space-y-4" data-id="element-188">
              <h1 className="text-[28px] sm:text-[34px] lg:text-[42px] xl:text-[52px] leading-tight font-serif font-bold" data-id="element-189">
                El protocolo de 14 días que está ayudando a mujeres españolas a
                eliminar la hinchazón, recuperar energía y volver a sentirse
                ellas mismas — sin dietas imposibles ni médicos que no te
                escuchan
              </h1>
              <p className="text-brand-gold text-[18px] sm:text-[22px] font-sans font-medium" data-id="element-190">
                No es tu culpa. Es tu biología. Y tiene solución en 14 días.
              </p>
            </div>

            <div className="flex flex-col space-y-4 pt-4" data-id="element-191">
              <a href="https://pay.hotmart.com/W104988940M?off=y9azogt4&checkoutMode=10&bid=1774913274137" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="bg-brand-gold text-brand-dark text-center font-bold text-lg sm:text-xl py-4 px-8 rounded-full hover:bg-yellow-500 transition-colors shadow-lg min-h-[56px] flex items-center justify-center" data-id="element-192">
                SÍ, QUIERO MI REINICIO →
              </a>

              <div className="flex flex-wrap justify-center gap-4 text-sm sm:text-base text-gray-300 font-medium" data-id="element-193">
                <div className="flex items-center" data-id="element-194">
                  <Lock className="w-4 h-4 mr-1.5 text-brand-gold" data-id="element-195" />
                  <span data-id="element-196">Pago seguro</span>
                </div>
                <div className="flex items-center" data-id="element-197">
                  <Zap className="w-4 h-4 mr-1.5 text-brand-gold" data-id="element-198" />
                  <span data-id="element-199">Acceso inmediato</span>
                </div>
                <div className="flex items-center" data-id="element-200">
                  <ShieldCheck className="w-4 h-4 mr-1.5 text-brand-gold" data-id="element-201" />
                  <span data-id="element-202">Garantía 15 días</span>
                </div>
              </div>
            </div>
          </div>

          <div className="relative flex justify-center lg:justify-end" data-id="element-203">
            <div className="relative w-full max-w-md lg:max-w-lg" data-id="element-204">
              <div className="absolute inset-0 bg-brand-gold/20 blur-3xl rounded-full hidden md:block" data-id="element-205"></div>
              <img src="https://cdn.magicpatterns.com/uploads/tJbPjAGTwuLr3gh2PY2nnk/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS_(1)_(1).webp" alt="El Reinicio Biológico y Bonos" width="500" height="500" fetchPriority="high" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-206" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}